import React from "react";

interface UnderlineButtonProps {
    text?: string,
    dataTestId?: string,
    click: () => void,
    className?: string,
}

const UnderlineButton = ({text, dataTestId, click, className}: UnderlineButtonProps) => {
    return <button data-testid={dataTestId} onClick={click} className={className || 'underline-button'}>{text}</button>;
};

export default UnderlineButton;
